import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionSubtitleRequest } from './get-collection-subtitle-request';
import type { IGetCollectionSubtitleResponse } from './get-collection-subtitle-response';
import { getCollectionSubtitleResponseSchema } from './get-collection-subtitle-response';

export async function getCollectionSubtitleApi({
  id,
}: IGetCollectionSubtitleRequest): Promise<IValidatedResponse<IGetCollectionSubtitleResponse>> {
  return getRequest<IGetCollectionSubtitleResponse>({
    path: `/sys/subtitles/${id}`,
    schema: getCollectionSubtitleResponseSchema,
  });
}
